import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { compose } from 'redux';

import { getInDomain } from '../../../domains/externalUtils';
import { StationGridItemModule } from '../deps';

const {
  mapDispatchToProps,
  mapStateToPropsWithoutStation,
  mapStateToPropsWithStation,
  PureStationGridItem,
  stationMapStateToPropsFactory,
} = StationGridItemModule;

function backstageMapStateToPropsWithStation(state, ownProps, station) {
  const props = mapStateToPropsWithStation(state, ownProps, station);
  const isPandoraIdInCollection = getInDomain('collection.utils.isPandoraIdInCollection', false);
  const stationFactoryPandoraId = station.get('stationFactoryPandoraId');
  props.isCollected = isPandoraIdInCollection(state, stationFactoryPandoraId);
  // Don't show "Created By" on BSP
  props.createdBy = null;

  return props;
}

export const mapStateToProps = stationMapStateToPropsFactory(
  backstageMapStateToPropsWithStation,
  mapStateToPropsWithoutStation,
);

const enhance = compose(
  // We use injectIntl here because there was some inexplicable performance issues when using <FormattedMessage> directly in the props
  injectIntl,
  connect(mapStateToProps, mapDispatchToProps),
);

export default enhance(PureStationGridItem);
